import * as actionTypes from "../action-types";
import Http from "../../layout/Http";
import setCookie from "../../utils/setCookie";
import deleteCookie from "../../utils/deleteCookie";
import sanitizeName from "../../utils/sanitizeName";
const initialState = {
    isAuthenticated: false,
    authenticated: false,
    access_token: null,
    user: {},
    lang: "en",
};

const normalizeUser = (user) => {
    if (!user) return {};
    return { ...user, name: sanitizeName(user.name) };
};

const authLogin = (state, action) => {
    Http.defaults.headers.common.Authorization = action.payload.access_token;
    setCookie(
        "ts_access_token",
        action.payload.shop_id,
        action.payload.access_token
    );
    return {
        ...state,
        isAuthenticated: action.payload.status,
        authenticated: action.payload.status,
        access_token: action.payload.access_token,
        user: normalizeUser(action.payload.user),
    };
};

const authLogout = (state, action) => {
    deleteCookie("ts_access_token");
    deleteCookie("ts_customer_info");
    return {
        ...state,
        isAuthenticated: false,
        authenticated: false,
        access_token: null,
        user: {},
    };
};

const updateUserInfo = (state, action) => {
    const user_info = normalizeUser(action.payload.user_info);
    setCookie("ts_customer_info", action.payload.shop_id, user_info);
    return {
        ...state,
        user: user_info,
    };
};

const Auth = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_LOGIN:
            return authLogin(state, action);
        case actionTypes.AUTH_LOGOUT:
            return authLogout(state, action);
        case actionTypes.UPDATE_USER_INFO:
            return updateUserInfo(state, action);
        default:
            return state;
    }
};

export default Auth;
